import { render, staticRenderFns } from "./loading-bg-component.vue?vue&type=template&id=0d71782c&lang=html"
import script from "./loading-bg-component.vue?vue&type=script&lang=js"
export * from "./loading-bg-component.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports